/*
 * @Author: Chao Yang
 * @Date: 2019-12-13 06:55:16
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 09:14:00
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Document from 'src/app/domain/model/document';
import { FolderProxy } from 'src/app/domain/proxy';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class FolderService {
  constructor(
    private _folderProxy: FolderProxy
  ) {}

  getFoldersWithEffectiveDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    effectiveDateFrom: Date,
    effectiveDateTo: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._folderProxy
      .getFoldersWithEffectiveDate(
        fundIds,
        accountIds,
        folderId,
        effectiveDateFrom,
        effectiveDateTo,
        accounts
      )
      .pipe(
        map(folders => {
          folders.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          if (folders.length > 0) {
            const folder = {
              id: -1,
              name: 'All Documents',
              unread: folders.reduce((s, f) => s + f.unread, 0),
              count: folders.reduce((s, f) => s + f.count, 0)
            };
            folders.splice(0, 0, folder);
          }
          return folders;
        })
      );
  }

  getFoldersWithPostedDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    postedDateFrom: Date,
    postedDateTo: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._folderProxy
      .getFoldersWithPostedDate(
        fundIds,
        accountIds,
        folderId,
        postedDateFrom,
        postedDateTo,
        accounts
      )
      .pipe(
        map(folders => {
          folders.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          if (folders.length > 0) {
            const folder: Document.IFolder = {
              id: -1,
              name: 'All Documents',
              unread: folders.reduce((s, f) => s + f.unread, 0),
              count: folders.reduce((s, f) => s + f.count, 0)
            };
            folders.splice(0, 0, folder);
          }
          return folders;
        })
      );
  }

  getTaxFolders(
    fundIds: number[],
    accountIds: number[],
    from: Date,
    to: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFolder[]> {
    return this._folderProxy
      .getTaxFolders(
        fundIds,
        accountIds,
        from,
        to,
        accounts
      )
      .pipe(
        map(folders => {
          folders.sort((a, b) => {
            return -a.name.localeCompare(b.name);
          });
          return folders;
        })
      );
  }
}
